// import type { DataLoaderParams } from '@/types/DataLoaderParams';
import { ConversationQueryType, fetchConversationsIfNeeded } from '@/redux/modules/conversation';
import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchConversationFoldersIfNeeded } from '@/redux/modules/conversationFolders';
import { parseQueryParams } from '@/utils/queryParams';

export default ({ location, store }: DataLoaderParams) => {
    const params: ConversationQueryType = parseQueryParams(location.search);
    const { dispatch } = store;

    return Promise.all([dispatch(fetchConversationFoldersIfNeeded()), dispatch(fetchConversationsIfNeeded(params))]);
};
